import React from "react";
import { Translate } from "react-localize-redux";
import {
  useReceivedContactInvites,
  useFetchContactInvites
} from "../../redux/effects/contacts.effects";
import ContactInviteCard from "../../components/ContactInviteCard";

const ContactRequestsDetail = ({ showClose, toggleModal }) => {
  const receivedContactInvites = useReceivedContactInvites();

  useFetchContactInvites();

  return (
    <div className="col-lg-12 text-center">
      <br />
      <h3 className="modal-title">
        <Translate id="contactRequests" />
      </h3>
      <br />

      {receivedContactInvites.length ? (
        <React.Fragment>
          {receivedContactInvites.map(invite => (
            <ContactInviteCard invite={invite} />
          ))}
        </React.Fragment>
      ) : (
        <h5>No Contact Requests</h5>
      )}

      <br />
      {showClose && (
        <div className="row">
          <div className="col-lg-12 text-center">
            <button
              className="btn btn-primary edit-profile-header-cancel-btn"
              onClick={toggleModal}
            >
              <Translate id="Close" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactRequestsDetail;



// WEBPACK FOOTER //
// ./src/components/ContactRequestsDetail/ContactRequestsDetail.jsx